import React from "react";
import { Route, Routes } from "react-router-dom";
import { DriveProvider } from "../../../contexts/DriveContext";
import Drive from "../drive/Drive/Drive";
import Participantfiles from "../participantfiles/Participantfiles";
import DriveParticipant from "../drive/Drive/caseFileDrive/DriveParticipant";
import DriveYear from "../drive/Drive/caseFileDrive/DriveYear";
import PersonalDrive from "../drive/Drive/personalDrive/PersonalDrive";
import SharedFilesDrive from "../drive/Drive/sharedFilesDrive/SharedFilesDrive";
import "../../../assets/css/drive.css";
import EmployeeFilesDrive from "../drive/Drive/employeeFileDrive/EmployeeFilesDrive";
export default function DriveRoutes() {
  return (
    <Routes>
      <Route
        path="/*"
        element={
          <DriveProvider>
            <Drive />
          </DriveProvider>
        }
      >
        {/* CaseFileDrive with and without employeeId */}
        {/* <Route
                      path="caseFileDrive/employee/:employeeId"
                      element={<CaseFileDrive />}
                    /> */}
        <Route
          path="caseFileDrive/employee/:employeeId"
          element={<Participantfiles />}
        />
        {/* <Route path="caseFileDrive" element={<CaseFileDrive />} /> */}
        <Route path="caseFileDrive" element={<Participantfiles />} />
        {/* DriveParticipant with employeeId */}
        <Route
          path="caseFileDrive/employee/:employeeId/participant/:participantId"
          element={<DriveParticipant />}
        />
        <Route
          path="caseFileDrive/participant/:participantId"
          element={<DriveParticipant />}
        />
        {/* DriveYear with employeeId */}
        <Route
          path="caseFileDrive/employee/:employeeId/participant/:participantId/:year"
          element={<DriveYear />}
        />
        <Route
          path="caseFileDrive/participant/:participantId/:year"
          element={<DriveYear />}
        />
        {/* <Route path="personal" element={<PersonalDrive />}>
                      <Route index element={<PersonalDrive />} />
                      <Route path=":folderId" element={<PersonalFolder />} />
                    </Route> */}
        <Route path="personal" element={<PersonalDrive />}>
          <Route index element={<PersonalDrive />} />
          <Route path=":folderId" element={<PersonalDrive />} />
        </Route>
        <Route path="employee-files" element={<SharedFilesDrive />} />
      </Route>
    </Routes>
  );
}
